import { Link } from "@tanstack/react-router";
import { BarChart3, Shield } from "lucide-react";
import { FavoriteButton } from "./FavoriteButton";

interface ChartData {
    id: number;
    title: string;
    description: string | null;
    author: { name: string };
    versionCount: number;
    currentUserPermission: string | null;
    activeVersion?: { aiSummary: { summary?: string } | null } | null;
}

export const ChartCard = ({ chart, target }: { chart: ChartData; target?: string }) => {
    const aiSummary = chart.activeVersion?.aiSummary?.summary;

    return (
        <Link
            to="/visualizations/$id"
            params={{ id: String(chart.id) }}
            target={target}
            className="block rounded-2xl border border-green-200 bg-white p-4 no-underline shadow-sm transition-shadow hover:shadow-md"
        >
            <div className="mb-2 flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                    <BarChart3 className="h-4 w-4 text-green-600" />
                    <span className="rounded-full bg-green-100 px-2 py-0.5 text-[10px] font-medium text-green-700">
                        Chart
                    </span>
                    {chart.currentUserPermission && (
                        <span className="flex items-center gap-0.5 text-[10px] text-gray-400">
                            <Shield className="h-3 w-3" />
                            {chart.currentUserPermission}
                        </span>
                    )}
                </div>
                <FavoriteButton target={{ type: "chart", id: chart.id }} size={16} />
            </div>
            <h3 className="line-clamp-2 text-base font-semibold text-gray-900">{chart.title}</h3>
            {chart.description && (
                <p className="line-clamp-2 mt-1 text-sm text-gray-500">{chart.description}</p>
            )}
            {aiSummary && (
                <p className="line-clamp-2 mt-1 text-xs italic text-gray-400">{aiSummary}</p>
            )}
            <div className="mt-2 flex items-center gap-2 text-xs text-gray-500">
                <span>{chart.author.name}</span>
                <span>·</span>
                <span>
                    {chart.versionCount} version{chart.versionCount !== 1 ? "s" : ""}
                </span>
            </div>
        </Link>
    );
};
